module.exports = __webpack_public_path__ + "files/41500cbd99f57c45813a9641211645d3.png";